const WORDS = [
  "Custom Cabinets",
  "Architectural Millwork",
  "Built-Ins",
  "Kitchen Islands",
  "Bespoke Furniture",
  "Where wood meets artistry",
];

export function Marquee() {
  const items = [...WORDS, ...WORDS];
  return (
    <div data-testid="marquee" className="bg-sage border-y border-charcoal/20 py-5 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {items.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-charcoal text-2xl md:text-3xl px-8">{w}</span>
            <span className="text-terracotta text-2xl">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
